import { AuthenticationType } from "./authentication-type";
import { CloudDriveProvider } from "@app/models/clouddrive/clouddrive-provider.model";

export class AuthenticatedModel {
  public id: number;
  public userName: string;
  public name: string;
  public surname: string;
  public profilePicture: string;
  public email: string;
  public clientId: number;
  public profilePictureBase64: string;
  public profilePictureName: string;
  public isSystemAdmin: boolean;
  public domainName: string;
  public authenticationType: AuthenticationType;
  public uploadProvider: CloudDriveProvider;
  public roles: Array<number>;
  public assignedFunctions: Array<number>;
  public isSsoUser: boolean;
}
